import { render, staticRenderFns } from "./newPermission.vue?vue&type=template&id=320c5c02&scoped=true"
import script from "./newPermission.vue?vue&type=script&lang=js"
export * from "./newPermission.vue?vue&type=script&lang=js"
import style0 from "./newPermission.vue?vue&type=style&index=0&id=320c5c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c5c02",
  null
  
)

export default component.exports